export const oktaConfig = {
  clientId: process.env.REACT_APP_OKTA_CLIENT_ID || '0oadj4pyw5WppApYE1d7',
  issuer: process.env.REACT_APP_OKTA_ISSUER || 'https://argogroup.oktapreview.com',
  redirectUri: `${process.env.REACT_APP_BASE_URL}/implicit/callback`,
  postLogoutRedirectUri: `${process.env.REACT_APP_BASE_URL}/logout`,
  scopes: ['openid', 'profile', 'email', 'groups'],
  pkce: true,
};
